module.exports = __webpack_public_path__ + "img/todasempresas.0a9b3559.png";